import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Avatar, Flex, Typography, Divider, theme, Grid } from "antd";
import FavoritesComponent from "./../../../components/favoritesComponent/FavoritesComponent.js";
import { FAVORITE_CATEGORIES } from "./../../../components/favoritesComponent/favoritesService.js";
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;
const TeamHeader = ({
  imageUrl,
  name,
  founded,
  venue,
  country,
  isFavorite,
  itemId,
  children
}) => {
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "content-gray-box teams-header",
      style: { paddingBottom: 0 },
      children: [
        /* @__PURE__ */ jsxs(
          Flex,
          {
            style: { marginBottom: screens.md ? 16 : 12 },
            justify: "space-between",
            children: [
              /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 12, children: [
                /* @__PURE__ */ jsx(
                  Avatar,
                  {
                    src: imageUrl,
                    shape: "square",
                    size: screens.md ? 64 : 32,
                    style: {
                      borderRadius: 0,
                      flexShrink: 0
                    }
                  }
                ),
                /* @__PURE__ */ jsxs(Flex, { vertical: true, children: [
                  /* @__PURE__ */ jsx(
                    Title,
                    {
                      level: 3,
                      style: { marginTop: 0, marginBottom: 4 },
                      children: name
                    }
                  ),
                  /* @__PURE__ */ jsxs(Flex, { align: "center", style: { flexWrap: "wrap" }, children: [
                    /* @__PURE__ */ jsx(
                      Text,
                      {
                        style: {
                          fontSize: token.fontSizeXS,
                          color: token.colorTextSecondary
                        },
                        children: country.name
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Divider,
                      {
                        type: "vertical",
                        style: {
                          borderColor: token.colorTextSecondary
                        }
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Text,
                      {
                        style: {
                          fontSize: token.fontSizeXS,
                          color: token.colorTextSecondary
                        },
                        children: venue == null ? void 0 : venue.name
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Divider,
                      {
                        type: "vertical",
                        style: {
                          borderColor: token.colorTextSecondary
                        }
                      }
                    ),
                    /* @__PURE__ */ jsxs(
                      Text,
                      {
                        style: {
                          fontSize: token.fontSizeXS,
                          color: token.colorTextSecondary
                        },
                        children: [
                          "Est: ",
                          founded
                        ]
                      }
                    )
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ jsx(
                FavoritesComponent,
                {
                  category: FAVORITE_CATEGORIES.TEAM,
                  itemId,
                  isFavorite
                }
              )
            ]
          }
        ),
        children
      ]
    }
  );
};
var stdin_default = memo(TeamHeader);
export {
  stdin_default as default
};
